import { createMultiStyleConfigHelpers as h } from "@chakra-ui/react";
import { ThemeColorVariable as o, ThemeIconSizeVariable as t, ThemeFontSizeVariable as d, ThemeFontVariable as b, ThemeSpaceVariable as m, ThemeRadiusVariable as f } from "../../theme-types.js";
import { tagAnatomy as C } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const g = ["Primary", "Secondary", "Success", "Error", "Info", "Neutral", "Warning"], a = ".tag-dot", u = ".tag-icon", { definePartsStyle: n, defineMultiStyleConfig: p } = h(C.keys), x = g.reduce(
  (l, e) => {
    const i = l, c = `${e.toLowerCase()}Solid`, s = e, r = `On${e}`;
    return i[c] = n({
      container: {
        backgroundColor: o[s],
        color: o[r],
        [a]: {
          backgroundColor: o[r]
        }
      }
    }), i;
  },
  {}
), y = g.reduce(
  (l, e) => {
    const i = l, c = `${e.toLowerCase()}`, s = e, r = `${e}Container`, S = `On${e}Container`;
    return i[c] = n({
      container: {
        color: o[S],
        backgroundColor: o[r],
        [a]: {
          backgroundColor: o[s]
        }
      }
    }), i;
  },
  {}
), V = n({
  container: {
    display: "flex",
    alignContent: "center",
    justifyContent: "flex-start",
    width: "fit-content",
    gap: m.XSmall,
    px: m.Small,
    bg: o.NeutralContainer,
    color: o.OnNeutralContainer,
    borderRadius: f.Small
  },
  label: {
    alignItems: "center",
    fontWeight: "500",
    lineHeight: "150%",
    mx: m.XSmall,
    letterSpacing: "0.0125em",
    font: b.Body
  },
  closeButton: {
    opacity: "0.48",
    margin: 0
  }
}), w = n({
  container: {
    minHeight: "24px",
    [a]: {
      width: "12px",
      height: "12px"
    },
    [u]: {
      height: t.Small,
      width: t.Small
    }
  },
  label: {
    fontSize: d.Small
  },
  closeButton: {
    fontSize: t.Small
  }
}), z = n({
  container: {
    minHeight: "32px",
    [a]: {
      width: "14px",
      height: "14px"
    },
    [u]: {
      height: t.Medium,
      width: t.Medium
    }
  },
  label: {
    fontSize: d.Medium
  },
  closeButton: {
    fontSize: t.Medium
  }
}), M = n({
  container: {
    minHeight: "40px",
    [a]: {
      width: "14px",
      height: "14px"
    },
    [u]: {
      height: t.Medium,
      width: t.Medium
    }
  },
  label: {
    fontSize: d.Large
  },
  closeButton: {
    fontSize: t.Medium
  }
}), T = n({
  container: {
    color: o.OnSurface,
    backgroundColor: o.SurfaceDisabled,
    [a]: {
      backgroundColor: o.OnSurface
    }
  }
}), v = {
  xs: w,
  sm: z,
  md: M
}, O = p({
  baseStyle: V,
  sizes: v,
  variants: {
    ...x,
    ...y,
    comboboxItem: T
  }
});
export {
  O as tagConfig
};
